import apiUrl from './ApiUrl'

const envConfig = {
    url : apiUrl()
}

const trackingReports = async (params,setTrackingReports) => {
    let data = null; 

    try {
        const response = await fetch(`${envConfig.url}/api/v2/reports?${params}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
              'Cache-Control': 'no-cache'
            }
        });    
        if (response.ok) {
            data = await response.json();
            console.log(data);
            setTrackingReports(data.data);
        } else {
            setTrackingReports(data);
        }
    } catch (error) {
        console.error("Error en la solicitud:", error);
        setTrackingReports(null);
    }
    
    return data;
};

const getProcesses = async (setProcesses) => {
    let data = null;

    try {
        const response = await fetch(`${envConfig.url}/api/v2/processes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                'Cache-Control': 'no-cache'
            }
        });

        if (response.ok) {
            data = await response.json();
            data.data.unshift({ id: 0, name: 'Todos' });
            setProcesses(data.data);
        } else {
            setProcesses([]);
        }
    } catch (error) {
        console.error("Error en la solicitud:", error);
        setProcesses([]);
    }

    return data;
};

export { trackingReports, getProcesses };
export default envConfig;
